import Button from "@/components/ui/button/Button";
import Alert from "@/components/ui/alert/Alert";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import Label from "@/components/Usados/Label";
import Input from "@/components/Usados/InputField";
import Autocomplete from "@/components/Usados/AutoComplete";
import Select from "@/components/Usados/Select";
import Switch from "@/components/form/switch/Switch";
import TextArea from "@/components/Usados/TextArea";
import DatePicker from "@/components/Usados/date-picker";
import { apiFetch } from "@/service/api";

export default function CrearUsuarioTab({
  usuario,
  empleadoProyecto,
  onSuccess,
  onCancel,
}: any) {
  const { id: proyecto_id } = useParams();
  const usuarioData = usuario || empleadoProyecto;
  const isEdit = !!usuarioData;

  const [form, setForm] = useState<any>({
    tarea: "",
    equipo_proyecto_id: "",
    empleado_id: "",
    rol_proyecto_id: "",
    fecha_inicio: "",
    fecha_fin: "",
    frecuencia_avance: "semanal",
    requiere_soporte: false,
    estado: "1",
    encuesta_asignada: false,
  });
  const [surveyForm, setSurveyForm] = useState({
    encuesta_id: "",
    observaciones: "",
    cantidad: "",
  });
  const [equipos, setEquipos] = useState<any[]>([]);
  const [empleados, setEmpleados] = useState<any[]>([]);
  const [roles, setRoles] = useState<any[]>([]);
  const [surveys, setSurveys] = useState<any[]>([]);
  const [surveyAssignmentId, setSurveyAssignmentId] = useState<number | null>(
    null,
  );
  const [file, setFile] = useState<File | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const fetchOpts = async () => {
      const [eq, rol, emp, surv] = await Promise.all([
        apiFetch(`equipos-proyectos/find-all-proyecto/${proyecto_id}`)
          .then((r) => r.json())
          .catch(() => []),
        apiFetch(`roles-proyectos/find-proyecto/${proyecto_id}`)
          .then((r) => r.json())
          .catch(() => []),
        apiFetch(`usuarios/find-all`)
          .then((r) => r.json())
          .catch(() => []),
        apiFetch(`survey/find-all`)
          .then((r) => r.json())
          .catch(() => []),
      ]);
      setEquipos(
        eq.map((e: any) => ({ value: e.id.toString(), label: e.nombre })),
      );
      setRoles(
        rol.map((r: any) => ({ value: r.id.toString(), label: r.nombre })),
      );
      setEmpleados(
        emp.map((u: any) => ({
          value: u.id.toString(),
          label: `${u.nombres} ${u.apellidos || ""}`,
        })),
      );
      setSurveys(
        surv.map((s: any) => ({ value: s.id.toString(), label: s.nombre })),
      );
    };
    fetchOpts();
  }, [proyecto_id]);

  useEffect(() => {
    if (usuarioData) {
      setForm({
        tarea: usuarioData.tarea || "",
        equipo_proyecto_id:
          usuarioData.equipo_proyecto?.id?.toString() ||
          usuarioData.equipo_proyecto_id?.toString() ||
          "",
        empleado_id:
          usuarioData.empleado?.id?.toString() ||
          usuarioData.empleado_id?.toString() ||
          "",
        rol_proyecto_id:
          usuarioData.rol_proyecto?.id?.toString() ||
          usuarioData.rol_proyecto_id?.toString() ||
          "",
        fecha_inicio: usuarioData.fecha_inicio?.split("T")[0] || "",
        fecha_fin: usuarioData.fecha_fin?.split("T")[0] || "",
        frecuencia_avance: usuarioData.frecuencia_avance || "semanal",
        requiere_soporte: !!usuarioData.requiere_soporte,
        estado: usuarioData.estado?.toString() || "1",
        encuesta_asignada: !!usuarioData.encuesta_asignada,
      });
      const loadEncuesta = async () => {
        try {
          const res = await apiFetch(`encuesta-usuario-proyecto/find-all`);
          if (res.ok) {
            const assignments: any[] = await res.json();
            let my = assignments.find(
              (a: any) => a.usuario?.id === usuarioData.id,
            );
            if (my) {
              setSurveyAssignmentId(my.id);
              setSurveyForm({
                encuesta_id: my.encuesta?.id?.toString() || "",
                observaciones: my.observaciones || "",
                cantidad: my.cantidad?.toString() || "",
              });
              setForm((prev: any) => ({ ...prev, encuesta_asignada: true }));
            }
          }
        } catch {}
      };
      loadEncuesta();
    }
  }, [usuarioData, proyecto_id]);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    try {
      const payload = {
        equipo_proyecto_id: Number(form.equipo_proyecto_id) || null,
        empleado_id: Number(form.empleado_id) || null,
        rol_proyecto_id: Number(form.rol_proyecto_id) || null,
        tarea: form.tarea,
        fecha_inicio: form.fecha_inicio,
        fecha_fin: form.fecha_fin,
        frecuencia_avance: form.frecuencia_avance,
        requiere_soporte: Boolean(form.requiere_soporte),
        estado: Number(form.estado),
        encuesta_asignada: Boolean(form.encuesta_asignada),
        proyecto_id: Number(proyecto_id),
      };
      const url = isEdit
        ? `empleados-proyectos/update/${usuarioData.id}`
        : `empleados-proyectos/create`;
      const method = isEdit ? "PATCH" : "POST";
      const res = await apiFetch(url, {
        method,
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message);

      let tareaId = isEdit ? usuarioData.id : data.id;

      if (!isEdit && form.fecha_inicio && form.fecha_fin) {
        await apiFetch(`avances-tareas/generar/${tareaId}`, {
          method: "POST",
          body: JSON.stringify({
            fecha_inicio: form.fecha_inicio,
            fecha_fin: form.fecha_fin,
            frecuencia: form.frecuencia_avance,
          }),
        });
      }

      if (file) {
        const fd = new FormData();
        fd.append("file", file);
        await apiFetch(`empleados-proyectos/upload-soporte/${tareaId}`, {
          method: "POST",
          body: fd,
        });
      }

      if (form.encuesta_asignada) {
        const surveyUrl = surveyAssignmentId
          ? `encuesta-usuario-proyecto/update/${surveyAssignmentId}`
          : `encuesta-usuario-proyecto/create`;
        const surveyMethod = surveyAssignmentId ? "PATCH" : "POST";
        await apiFetch(surveyUrl, {
          method: surveyMethod,
          body: JSON.stringify({
            proyecto_id: Number(proyecto_id),
            usuario_id: tareaId,
            encuesta_id: Number(surveyForm.encuesta_id),
            observaciones: surveyForm.observaciones,
            cantidad: Number(surveyForm.cantidad),
            cantidad_respuestas: 0,
          }),
        });
      }

      setSuccess(true);
      setTimeout(() => onSuccess?.(), 800);
    } catch (err: any) {
      setError(err.message);
    }
  };

  return (
    <div className="rounded-2xl border bg-white p-6">
      {error && <Alert variant="error" title="Error" message={error} />}
      {success && (
        <Alert variant="success" title="Éxito" message="Tarea guardada" />
      )}
      <form onSubmit={handleSubmit} className="space-y-6 max-w-4xl mx-auto">
        <div>
          <Label>Tarea / Descripción *</Label>
          <Input
            value={form.tarea || ""}
            onChange={(e: any) => setForm({ ...form, tarea: e.target.value })}
            required
            placeholder="Ej: Excavación y relleno"
          />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <Autocomplete
            label="Equipo"
            options={equipos}
            value={form.equipo_proyecto_id || ""}
            onChange={(id: any) => setForm({ ...form, equipo_proyecto_id: id })}
            placeholder="Seleccione equipo"
          />
          <Autocomplete
            label="Empleado"
            options={empleados}
            value={form.empleado_id || ""}
            onChange={(id: any) => setForm({ ...form, empleado_id: id })}
            placeholder="Seleccione empleado"
          />
          <Autocomplete
            label="Rol"
            options={roles}
            value={form.rol_proyecto_id || ""}
            onChange={(id: any) => setForm({ ...form, rol_proyecto_id: id })}
            placeholder="Seleccione rol"
          />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <Label>Fecha inicio *</Label>
            <DatePicker
              id="fecha_inicio"
              placeholder="Selecciona una fecha"
              defaultDate={form.fecha_inicio || ""}
              onChange={(selectedDates: any) => {
                if (selectedDates?.[0])
                  setForm({
                    ...form,
                    fecha_inicio: selectedDates[0].toISOString().split("T")[0],
                  });
              }}
            />
          </div>
          <div>
            <Label>Fecha fin *</Label>
            <DatePicker
              id="fecha_fin"
              placeholder="Selecciona una fecha"
              defaultDate={form.fecha_fin || ""}
              onChange={(selectedDates: any) => {
                if (selectedDates?.[0])
                  setForm({
                    ...form,
                    fecha_fin: selectedDates[0].toISOString().split("T")[0],
                  });
              }}
            />
          </div>
          <div>
            <Label>Frecuencia avances</Label>
            <Select
              value={form.frecuencia_avance || "semanal"}
              onChange={(v: any) => setForm({ ...form, frecuencia_avance: v })}
              options={[
                { value: "semanal", label: "Semanal" },
                { value: "quincenal", label: "Quincenal" },
                { value: "mensual", label: "Mensual" },
              ]}
            />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <Label>Estado</Label>
            <Select
              value={form.estado || "1"}
              onChange={(v: any) => setForm({ ...form, estado: v })}
              options={[
                { value: "1", label: "Pendiente" },
                { value: "2", label: "En Progreso" },
                { value: "3", label: "Completada" },
              ]}
            />
          </div>
          <div className="flex flex-col gap-2">
            <Label>Soporte obligatorio?</Label>
            <label className="flex items-center gap-2 text-sm mt-2">
              <input
                type="checkbox"
                checked={!!form.requiere_soporte}
                onChange={(e: any) =>
                  setForm({ ...form, requiere_soporte: e.target.checked })
                }
              />{" "}
              Requiere foto/documento en avances
            </label>
          </div>
        </div>
        <div className="border-t pt-6">
          <div className="flex items-center gap-3 mb-4">
            <Switch
              label="Asignar encuesta a esta tarea?"
              defaultChecked={!!form.encuesta_asignada}
              onChange={(checked: boolean) =>
                setForm({ ...form, encuesta_asignada: checked })
              }
            />
          </div>
          {form.encuesta_asignada && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 bg-blue-50/50 p-4 rounded-xl border border-blue-100">
              <Autocomplete
                label="Encuesta"
                options={surveys}
                value={surveyForm.encuesta_id || ""}
                onChange={(id: any) =>
                  setSurveyForm({ ...surveyForm, encuesta_id: id })
                }
                placeholder="Seleccione encuesta"
              />
              <div>
                <Label>Cantidad de encuestas a realizar *</Label>
                <Input
                  type="number"
                  value={surveyForm.cantidad || ""}
                  onChange={(e: any) =>
                    setSurveyForm({ ...surveyForm, cantidad: e.target.value })
                  }
                  placeholder="Ej: 50"
                />
              </div>
              <div className="col-span-2">
                <Label>Observaciones</Label>
                <TextArea
                  value={surveyForm.observaciones || ""}
                  onChange={(e: any) =>
                    setSurveyForm({
                      ...surveyForm,
                      observaciones: e.target ? e.target.value : e,
                    })
                  }
                  placeholder="Instrucciones para el usuario"
                />
              </div>
            </div>
          )}
        </div>
        <div>
          <Label>Adjuntar soporte inicial</Label>
          <input
            type="file"
            onChange={(e) => setFile(e.target.files?.[0] || null)}
            className="w-full border rounded-lg p-2 text-sm"
          />
        </div>
        <div className="flex gap-3">
          <Button type="submit">{isEdit ? "Actualizar" : "Crear"} Tarea</Button>
          <Button type="button" variant="outline" onClick={onCancel}>
            Cancelar
          </Button>
        </div>
      </form>
    </div>
  );
}
